import { render, staticRenderFns } from "./Factor.vue?vue&type=template&id=2cdbf77e&scoped=true&"
import script from "./Factor.vue?vue&type=script&lang=js&"
export * from "./Factor.vue?vue&type=script&lang=js&"
import style0 from "./Factor.vue?vue&type=style&index=0&id=2cdbf77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdbf77e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VDivider,VTab,VTabItem,VTabs})
